import React from "react";
import cx from "classnames";

import { useFieldQueryController } from "./field-query.controller";
import { FieldQueryProps } from "./field-query.types";

import { Controls } from "./components/controls";
import { Body } from "./components/body";
import { Header } from "./components/header";

import "./field-query.styles.scss";

export const FieldQuery = <T,>(props: FieldQueryProps<T>) => {
  const { className, disabled, items, placeholder, getId, columns, classes, onRowDrop, enableDragDrop } = props;

  const { selectedItemId, handleItemSelect, processedControls } = useFieldQueryController(props);

  return (
    <div className={cx("FieldQuery", { ["FieldQuery--disabled"]: disabled }, className)}>
      {placeholder && !items.length && <span className="FieldQuery__drag-drop-message">{placeholder}</span>}
      <div className="FieldQuery__table-wrapper">
        <table className="FieldQuery__table">
          <Header className="FieldQuery__table__header" columns={columns} getId={getId} />
          <Body
            columns={columns}
            rows={items}
            selectedRowId={selectedItemId}
            onItemClick={handleItemSelect}
            getId={getId}
            classes={classes}
            onRowDrop={onRowDrop}
            enableDragDrop={enableDragDrop}
          />
        </table>
      </div>
      {Boolean(processedControls.length) && <Controls controls={processedControls} />}
    </div>
  );
};
